import React, { useState } from "react";
import axios from 'axios';
import * as API from "../../Endpoints/Endpoints";
import { useNavigate } from 'react-router-dom';

const GameCategory = () => {
  const [formData, setFormData] = useState({
    gamecategory: "",
    gamecategoryname: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(API.POST_CATEGORY_API, formData);

      if (response.status === 201) {
        console.log("Form Data Submitted Successfully:", response.data);
        setFormData({
          gamecategory: "",
          gamecategoryname: "",
          
        });
        alert("Data submitted successfully!");
        navigate('/categorytable');
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting data.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
          Game Category Form
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Game Category */}
          <div className="mb-4">
            <label
              htmlFor="gamecategory"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Category
            </label>
            <input
              type="text"
              id="gamecategory"
              name="gamecategory"
              value={formData.gamecategory}
              onChange={handleChange}
              placeholder="Enter game category"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Game Category Name */}
          <div className="mb-4">
            <label
              htmlFor="gamecategoryname"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Category Name
            </label>
            <input
              type="text"
              id="gamecategoryname"
              name="gamecategoryname"
              value={formData.gamecategoryname}
              onChange={handleChange}
              placeholder="Enter game category name"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#e64a32] text-white py-2 px-4 rounded-lg hover:bg-[#e64a32] focus:outline-none"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default GameCategory;
